export default __webpack_public_path__ + "locales/ro/Common.json?hash=8f2fe43c61313c4221852214bd90b092";